import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/7615a796-d7b4-4aa0-bfc5-ddd01aab73da.jpg'
import { useIntl } from 'react-intl';

const TravbusinessSolutionsForTravelersHotelsCarsPage: React.FC = () => {
  const intl = useIntl();
  const tocItems: ITableOfContentItem[] = [
    { id: 'all-in-one-booking', title: '1. All-in-One Booking' },
    { id: 'flexible-options', title: '2. Flexible Options' },
    { id: 'customer-support', title: '3. 24/7 Customer Support' },
    { id: 'user-friendly-interface', title: '4. User-Friendly Interface' },
    { id: 'personalized-dashboard', title: '5. Personalized Dashboard' },
  ];
  
const sections: IContentSection[] = [
  {
    id: 'traveler-mgrs.all-in-one-booking',
    title: intl.formatMessage({ id: 'traveler-mgrs.all.in.one.booking' }),
    paragraphs: [
      intl.formatMessage({ id: 'traveler-mgrs.all.in.one.booking.p1' }),
      intl.formatMessage({ id: 'traveler-mgrs.all.in.one.booking.p2' }),
    ],
  },
  {
    id: 'traveler-mgrs.flexible-options',
    title: intl.formatMessage({ id: 'traveler-mgrs.flexible.options' }),
    paragraphs: [
      intl.formatMessage({ id: 'traveler-mgrs.flexible.options.p1' }),
      intl.formatMessage({ id: 'traveler-mgrs.flexible.options.p2' }),
    ],
  },
  {
    id: 'traveler-mgrs.customer-support',
    title: intl.formatMessage({ id: 'traveler-mgrs.customer.support' }),
    paragraphs: [
      intl.formatMessage({ id: 'traveler-mgrs.customer.support.p1' }),
    ],
  },
  {
    id: 'traveler-mgrs.user-friendly-interface',
    title: intl.formatMessage({ id: 'traveler-mgrs.user.friendly.interface' }),
    paragraphs: [
      intl.formatMessage({ id: 'traveler-mgrs.user.friendly.interface.p1' }),
      intl.formatMessage({ id: 'traveler-mgrs.user.friendly.interface.p2' }),
    ],
  },
  {
    id: 'traveler-mgrs.personalized-dashboard',
    title: intl.formatMessage({ id: 'traveler-mgrs.personalized.dashboard' }),
    paragraphs: [
      intl.formatMessage({ id: 'traveler-mgrs.personalized.dashboard.p1' }),
      intl.formatMessage({ id: 'traveler-mgrs.personalized.dashboard.p2' }),
    ],
  },
];


  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={intl.formatMessage({ id: 'traveler-mgrs.title' })}
        headerSubtitle={intl.formatMessage({ id: 'traveler-mgrs.subtitle' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='top'
      />
    </div>
  );
};

export default TravbusinessSolutionsForTravelersHotelsCarsPage;
